<div class="modal-header shadow-sm">
  <h6 class="modal-title" id="organizationSettingsModalLabel">{{ title }}</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modalRef.close()"
  ></button>
</div>
<div class="modal-body scrollbar-primary thin">
  @if (organizationName) {
    <p class="text-muted small mb-3">
      {{ organizationName }}
    </p>
  }
  <form [formGroup]="settingsForm" autocomplete="off">
    <div class="md-form mb-2">
      <div class="form-check form-switch d-flex align-items-center">
        <input
          class="form-check-input"
          type="checkbox"
          id="threatPairModuleEnabled"
          formControlName="threatPairModuleEnabled"
          />
        <label class="form-check-label ms-2" for="threatPairModuleEnabled">
          Threat pair module
        </label>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer justify-content-between pt-0 bg-gray-lighter">
  <button type="button" class="btn btn-gray-light" (click)="modalRef.close()">
    {{ cancelButtonLabel }}
  </button>
  <button
    type="button"
    class="btn btn-primary d-flex align-items-center"
    [disabled]="loading"
    (click)="save()"
    >
    @if (loading) {
      <span
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
    }
    Save
  </button>
</div>
